module.exports = {
  "updatePreferences": {
    "name": "subscriptions-usage",
    "class": "usage",
    "properties": {
      "action": [
        "Update Preferences"
      ]
    },
    "namespace": "unsubscribe-ui",
    "version": "1"
  },
  "unsubscribeAllPreferences": {
    "name": "subscriptions-usage",
    "class": "usage",
    "properties": {
      "action": [
        "Unsubscribe All Preferences"
      ]
    },
    "namespace": "unsubscribe-ui",
    "version": "1"
  },
  "changePreferedLanguage": {
    "name": "subscriptions-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "Change Preferred Language"
      ],
      "from-language": "string",
      "to-language": "string",
      "device-language-code": "string"
    },
    "namespace": "unsubscribe-ui",
    "version": "1"
  },
  "redirectToBackup": {
    "name": "subscriptions-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "Redirect to Backup Page"
      ],
      "reason": "string"
    },
    "namespace": "unsubscribe-ui",
    "version": "1"
  },
  "verifyContact": {
    "name": "subscriptions-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "Verify Contact"
      ],
      "success": "boolean",
      "error-type": "string"
    },
    "namespace": "unsubscribe-ui",
    "version": "1"
  }
};